import React from 'react';
import { User } from '@adjust/dashboard-core/api/types';
import { UserDetailScreen } from '@react/Pages/AccountSettingsPage/UserDetails/UserDetails/types';

interface Props {
  navigateTo: (screen: UserDetailScreen) => void;
  user: User;
  isAccountOwner: boolean;
}

export const UserDetailsMenu: React.FC<Props> = ({ user, isAccountOwner, navigateTo }) => {
  const showEmail = !user.sso;
  const showPassword = isAccountOwner && !user.sso;
  const showToken = isAccountOwner && user.api_access && !user.sso;

  return (
    <ul className="ul-list flex-auto">
      {showEmail && (
        <li className="flex-box-row">
          <a className="item-name flex-one" onClick={() => navigateTo(UserDetailScreen.EMAIL)}>
            {user.email}
          </a>
          <div className="item-options flex-auto">
            <a className="item-link" onClick={() => navigateTo(UserDetailScreen.EMAIL)}>
              {user.unconfirmed_email && <i className="icon icon-warning icon-unconfirmed-email" />}
              <i className="icon icon-arrow-right" />
            </a>
          </div>
        </li>
      )}

      {showPassword && (
        <li className="flex-box-row">
          <a className="item-name flex-one" onClick={() => navigateTo(UserDetailScreen.PASSWORD)}>
            {t('label.change-password')}
          </a>
          <div className="item-options flex-auto">
            <a className="item-link" onClick={() => navigateTo(UserDetailScreen.PASSWORD)}>
              <i className="icon icon-arrow-right" />
            </a>
          </div>
        </li>
      )}

      {showToken && (
        <li className="flex-box-row">
          <a className="item-name flex-one" onClick={() => navigateTo(UserDetailScreen.API_TOKEN)}>
            {t('label.reset-api-token')}
          </a>
          <div className="item-options flex-auto">
            <a className="item-link" onClick={() => navigateTo(UserDetailScreen.API_TOKEN)}>
              <i className="icon icon-arrow-right" />
            </a>
          </div>
        </li>
      )}
    </ul>
  );
};
